module.exports = __webpack_public_path__ + "img/ResetPanelDMP.fd016f11.svg";